<template>
  <div class="col-12 col-md-3 col-lg-2" v-b-tooltip.hover="{ variant: 'primary' }" :title="descricao">
    <button @click="funcao" class="row align-items-center mx-0" :class="destaque ? 'destaque' : 'cardPadrao'">
      <img v-if="image" :class="destaque ? 'icone-destaque' : ''" class="col-2 p-1" :src="image" :alt="textoAlternativo" />
      <h4 class="text-sm-nowrap mb-0 col-10" :class="destaque ? 'card-titulo-destaque' : 'card-titulo'">{{ titulo }}</h4>
    </button>
  </div>
</template>

<script>
export default {
  name: "botaoSuperior",
  props: {
    titulo: {
      type: String,
      required: true,
    },
    descricao: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: true,
    },
    textoAlternativo: {
      type: String,
      required: true,
    },
    funcao: {
      type: Function,
      required: true,
    },
    destaque: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>
.cardPadrao {
  border-radius: 0 0 1rem 1rem;
  background-color: #f5f5f5;
  border-color: #f5f5f5;
  width: 100%;
  border-bottom: 0.4rem solid #326496;
  transition: 0.3s;
}

.cardPadrao:hover {
  transform: scale(1.03);
  transition: 0.3s;
}

.destaque {
  border-radius: 0 0 1rem 1rem;
  background-color: #326496;
  border-color: #f5f5f5;
  width: 100%;
  border-bottom: 0.4rem solid #326496;
  transition: 0.3s;
}

.destaque:hover {
  transform: scale(1.03);
  transition: 0.3s;
}

.card-titulo {
  color: #000000;
  font-size: clamp(0.1rem, 0.9rem, 2rem);
  font-weight: 600;
}

.card-titulo-destaque {
  color: #FFFFFF;
  font-size: clamp(0.1rem, 0.9rem, 2rem);
  font-weight: 600;
}

.icone-destaque {
  filter: invert(1); 
}

button {
  border: none;
  cursor: pointer;
  outline: none;
}
</style>
